import Service from "../../Services";

const SupportContact = {
  namespaced : true,
  state : {
    form : {
      id : '',
      message : '',
      email : '',
      phone : '',
      is_reply : false,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
     state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        id : '',
        message : '',
        email : '',
        phone : '',
        is_reply : false,
      }
    }
  },
  actions : {
    getData({commit},page){
      return Service.CustomerSupportAPI.getContact(page);
    },
    showData({commit},id){
      return Service.CustomerSupportAPI.showContact(id);
    },
    saveData({commit},{id,data}){
      if(id){
        return Service.CustomerSupportAPI.updateContact(id,data);
      }else{
        return Service.CustomerSupportAPI.createContact(data);
      }
    },
    deleteData({commit},id){
      return Service.CustomerSupportAPI.deleteContact(id);
    },
    setFormData({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default SupportContact
